module.exports = __webpack_public_path__ + "static/img/ZRS2266_1.png";


//////////////////
// WEBPACK FOOTER
// ./src/assets/img/produkty/ZRS2266_1.png
// module id = OqcW
// module chunks = 0